import 'react-app-polyfill/ie11';
import 'core-js/stable';
import React from 'react';
import SpinnerGIf from '../images/Spinner.gif';
import Close from "../images/svgLatest/Close_blue_withoutCircle.svg";
import StaticLabels from "../util/staticLabels.json";
import SpinnerGIfGlobal from '../images/svgBranding/spinnerGlobal.gif';
import CloseGlobal from "../images/svgBranding/close.svg";
var classNames = require('classnames');



const Spinner = ({ isMaximised, showSPinner, handleModalChange }) => {
    var spinnerClass = classNames({
        spinnerClass: true,
        displayNone: !isMaximised || showSPinner,
    })
    var spinnerClose = classNames({
        spinnerClose: true,
        displayNone: !isMaximised || showSPinner,
    })
    return (
        <div className={spinnerClose}>
        <div>
                <a
                    href="#"
                    onClick={handleModalChange({
                        isOpenModal: false,
                        value: null,
                        target: "closeLaunchIcon"
                    })}
                >
                     <img alt="Close" title="Close Bot" src={window.config.isGlobalDomainUI?CloseGlobal:Close} ></img>
                </a>
            </div>
            <div className={spinnerClass}>
                <div className="spinnergif">
                    <img alt="spinner" width={176} height={176} src={window.config.isGlobalDomainUI?SpinnerGIfGlobal:SpinnerGIf}></img>
                    <div style={{ position: "relative" }}>
                        {window.config.businessUnit === 'HBT-GCEGBT' ?  
                        <h1 id="spinner-text" className="spinner-text">{window?.config?.language ? StaticLabels?.[window?.config?.language]?.NowLoading : StaticLabels?.en?.NowLoading}</h1>
                        :
                        <h1 id="spinner-text" className="spinner-text">Now loading, please wait ...</h1>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Spinner;